import { useEffect } from 'react';
import { useFormik } from 'formik';
import { IParams } from '../../../../../../shared/types/redirectParams';

export const useFinalCausalityRegisterHistory = (finalCausality?: IParams) => {
    const formik = useFormik({
        initialValues: {
            createdBy: '',
            updatedBy: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        const { createdBy, updatedBy } = finalCausality || {};
        formik.setValues({
            createdBy: createdBy
                ? `(${createdBy.username}) ${createdBy.name} ${createdBy.surname}`
                : '',
            updatedBy: updatedBy
                ? `(${updatedBy.username}) ${updatedBy.name} ${updatedBy.surname}`
                : '',
        });
    }, [finalCausality]);

    return {
        formik,
    };
};
